import { EMAIL_REGEX } from '../../../utils';

const validate = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = 'Required';
  }
  if (!values.body) {
    errors.body = 'Required';
  }
  if (!values.name) {
    errors.name = 'Required';
  }
  if (!values.reason) {
    errors.reason = 'Required';
  }
  return errors;
};

export default validate;
